import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { ExecutionResult, LcsApiService } from '@lcs/shared/api';
import { MailboxInput } from 'generated/graphql-types';
import { Observable } from 'rxjs';
import { MailboxDetailSaveModel } from '../models/mailbox-detail-save.model';
import { GetMailboxDetail, GetMailboxDetailVariables } from '../queries/generated/GetMailboxDetail';
import { SaveMailbox, SaveMailboxVariables } from '../queries/generated/SaveMailbox';
import { getMailboxDetail } from '../queries/mailbox-detail.graphql';
import { SaveMailboxMutation } from '../queries/save-mailbox.graphql';

@Injectable({ providedIn: 'root' })
export class MailboxDetailApiService {
   constructor(private apiService: LcsApiService, private http: HttpClient) {}

   save(
      mailboxDetail: MailboxDetailSaveModel,
      fields: (keyof MailboxInput)[]
   ): Observable<ExecutionResult<SaveMailbox>> {
      return this.apiService.query<SaveMailbox, SaveMailboxVariables>({
         query: SaveMailboxMutation,
         variables: {
            mailbox: {
               ...mailboxDetail,
               fields: fields,
            },
         },
      });
   }

   changePin(mailboxId: number, pin: string): Observable<any> {
      return this.http.post<any>('/api/Mailboxes/ChangeMailboxPin', {
         mailboxId,
         pin,
      });
   }

   get(id: number): Observable<ExecutionResult<GetMailboxDetail>> {
      return this.apiService.query<GetMailboxDetail, GetMailboxDetailVariables>({
         query: getMailboxDetail,
         variables: {
            id,
         },
      });
   }
}
